module.exports = __webpack_public_path__ + "img/reissue_allowance.a976c482.png";